<template>
  <div :class="$style.commandsMainPanel">
    <AnnouncementWrapper
      v-if="showAnnouncement"
      :caretOffset="announcement.caretOffset"
      :caretPointsTo="announcement.caretPointsTo"
      :class="$style.announcement"
      :header="announcement.header"
      :localStorageKey="announcement.localStorageKey"
      :mainActionText="announcement.mainActionText"
      :text="announcement.text"
      @main-action="handleTemplateAction"
    />
    <CommandItemTable
      ref="itemTable"
      :gettingStartedItemType="gettingStartedPanelItemType"
      :isAsideOpen="isAsideOpen"
      :itemType="itemType"
      :selectedModelId="selectedModelId"
      :setGettingStartedTooltipVisibility="showTooltip"
      :setSelectedModelId="setSelectedModelId"
      :useDropDownFilterComponent="FilterComponentConsts.CommandsDropDownFilter"
      :viewport="viewport"
    />
  </div>
</template>

<script>
import {
  FilterComponentConsts, ItemTypeConsts, LocalStorageConsts, StoreModuleMap,
} from 'client/util/Constants';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters } from 'vuex';
import AnnouncementWrapper from 'client/components/Announcement/AnnouncementWrapper.vue';
import CommandItemTable from 'client/Commands/CommandItemTable.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const {
  description,
  location,
  text,
  toUrl,
} = eventProperties;
const { commandsPage } = eventLocations;

export default {
  name: 'CommandsMainPanel',

  components: {
    AnnouncementWrapper,
    CommandItemTable,
  },

  mixins: [MainPanelMixin],

  data: () => ({
    FilterComponentConsts,
    announcement: {
      header: 'Improve efficiency with Command templates',
      localStorageKey: LocalStorageConsts.commandtemplateAnnouncementSeen,
      text: 'Use Command templates to automate tasks that can be applied across all your organizations.',
      mainActionText: 'Explore',
      caretOffset: 20,
      caretPointsTo: 'left',
    },
  }),
  computed: {
    ...mapGetters(settingsModule, [
      'isAdminWithBilling',
      'isProvider',
    ]),
    showAnnouncement() {
      return this.isProvider && this.isAdminWithBilling;
    },
  },
  methods: {
    handleTemplateAction() {
      const commandsFromTemplateRoute = '#/commands/newfromtemplate';
      this.$router.push('/commands/newfromtemplate');
      EventHelper.triggerButtonClicked({
        [description]: 'opens new commands template page',
        [location]: commandsPage,
        [text]: this.$options.commandFromTemplateText,
        [toUrl]: commandsFromTemplateRoute,
      });
    },
  },
};
</script>

<style module>
.commandsMainPanel {
  height: 100%;
}

.announcement {
  left: 90px;
  position: absolute;
  top: 60px;
}
</style>
